import React, { useMemo } from "react";

import Alert from "veneer/Alert";

import {
  ARCHIVE_STATUS_CHILDREN,
  ARCHIVE_STATUS_ENTRY,
} from "cortex/ui/src/fleet/constant/mediaLibrary";
import type { Media } from "cortex/ui/src/fleet/view/media-library/model";
import { getArchiveStatus } from "cortex/ui/src/fleet/view/media-library/utils";

interface ContentArchivedProps {
  mediaEntry: Partial<Media>;
  parentOnly?: boolean;
}

function ContentArchived({
  mediaEntry,
  parentOnly = false,
}: ContentArchivedProps) {
  const archiveStatus = useMemo(
    () =>
      getArchiveStatus(mediaEntry as Parameters<typeof getArchiveStatus>[0]),
    [mediaEntry],
  );

  if (!archiveStatus) return null;
  if (archiveStatus === ARCHIVE_STATUS_CHILDREN && parentOnly) return null;

  const friendlyType = mediaEntry.friendlyType ?? "item";
  const archiveTitle =
    archiveStatus === ARCHIVE_STATUS_ENTRY
      ? `This ${friendlyType} is archived.`
      : `This ${friendlyType} contains archived content.`;

  return (
    <Alert dense severity="warning" title={archiveTitle}>
      It will still play, but you cannot add it to other strategies.
    </Alert>
  );
}

export { ContentArchived };
export default ContentArchived;
